// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"68693753","512":"9b6be869","620":"7be08520","648":"a050255b","934":"351c0e17","977":"5954ca21"}[chunkId] + ".chunk.js";
};